<div class="period__container">
    <div class="period__label">{{label()}}</div>
    <div class="period__date">
        <div>{{dateTime()?.start }}</div>-
        <div>{{dateTime()?.end }}</div>
        @if (promoType() === 'affiliate') {
            <span>WIB</span>
        }
    </div>
</div>
